import http from '@/requests/http'

class TaskCategory {
  static all (params) {
    return http.post('configuration/task/category/index', params)
  }
  static async update (data) {
    return http.post('configuration/task/category/update', data)
  }
  static async view (params) {
    return http.post('configuration/task/category/view', params)
  }
  static async save (data) {
    return http.post('configuration/task/category/store', data)
  }
  static async delete (id) {
    return http.post(`configuration/task/category/delete/${id}`)
  }
}

export default TaskCategory
